<!-- src/components/device/MaintenanceWindowAlert.vue -->
<!-- Encadré à afficher dans tout onglet où l'utilisateur peut envoyer une commande MQTT.
     Visible uniquement quand la fenêtre maintenance est ouverte côté device.
     Émet @close lorsque l'utilisateur veut fermer la fenêtre. -->
<template>
  <div v-if="open" class="bg-purple-50 border-2 border-purple-200 rounded-lg shadow p-4 mb-6">
    <div class="flex items-center justify-between mb-3">
      <h3 class="font-semibold text-purple-800 flex items-center gap-2">
        🔧 Fenêtre de maintenance ouverte
      </h3>
      <span class="text-2xl font-bold text-purple-700 tabular-nums">{{ countdown }}s</span>
    </div>
    <button
      type="button"
      class="btn btn-secondary w-full text-sm"
      :disabled="loading"
      @click="$emit('close')"
    >
      Fermer la fenêtre maintenance
    </button>
    <p class="text-xs text-purple-700 mt-2">
      Toute commande envoyée pendant la fenêtre maintenance prolonge automatiquement le compte à rebours à 120 s.
      Cliquez sur «&nbsp;Fermer&nbsp;» pour repasser le device en veille immédiatement.
    </p>
  </div>
</template>

<script>
export default {
  name: 'MaintenanceWindowAlert',
  props: {
    open: { type: Boolean, default: false },
    countdown: { type: Number, default: 0 },
    loading: { type: Boolean, default: false }
  },
  emits: ['close']
};
</script>
